import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { supplierForecastService } from 'services/fdp/supplierForecastService';
export const useSupplierForecast = () => {
  const {
    UserStore: { userModulesRoles },
    SupplierForecastStore: {
      isSupplierForecastLoading,
      isSupplierForecastDownloading,
      setIsSupplierForecastDownloading,
      isAllSupplierForecastDownloading,
      setIsAllSupplierForecastDownloading,
      supplierNames,
      supplierForecastData,
      suplierForecastPlanDate,
      supplierOption,
      fssforecastData,
      nmcforecastData,
      coveredDrugForecastData,
      issupplierForecastGenerating,
      isUnconstrainedForecastProgressLoading,
      percentProgress,
      searchInput,
      setSupplierOption,
      getSupplierForecastData,
      generateSupplierForecast,
    },
  } = useStore();

  const handleExport = async () => {
    try {
      setIsSupplierForecastDownloading(true);
      const _currDt = new Date();
      // const forecast_period = currDt
      //   .toISOString()
      //   .split("T")[0]
      //   .replace(/-\d{2}$/, "-01");
      await supplierForecastService.downloadSupplierForecastExcelFile({
        supplier_name: supplierOption.name,
        planning_period: suplierForecastPlanDate,
      });
    } catch {
      toast.error('Supplier Forecast failed be download, try again later');
    } finally {
      setIsSupplierForecastDownloading(false);
    }
  };

  const handleExportAllSuppliers = async () => {
    try {
      setIsAllSupplierForecastDownloading(true);
      const _currDt = new Date();
      // const forecast_period = currDt
      //   .toISOString()
      //   .split("T")[0]
      //   .replace(/-\d{2}$/, "-01");
      await supplierForecastService.downloadAllSupplierForecastExcelFile({
        planning_period: suplierForecastPlanDate,
      });
    } catch (_error) {
      toast.error('Supplier Forecast failed to download, try again later');
    } finally {
      setIsAllSupplierForecastDownloading(false);
    }
  };

  // get future 15 months date
  const getFutureMonths = () => {
    const arr: { label: string; dateString: string }[] = [];
    const dt = new Date();
    const startMonth = dt.getMonth();
    const startYear = dt.getFullYear();
    const monthShortHand = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    for (let i = 0; i < 15; i++) {
      const month = (startMonth + i + 1) % 12;
      const year = startYear + Math.floor((startMonth + i + 1) / 12);
      arr.push({
        label: `${monthShortHand[month]}-${year}`,
        dateString: `${year}-${month >= 9 ? month + 1 : `0${month + 1}`}-01`,
      });
    }

    return arr;
  };
  const forecastDates: { label: string; dateString: string }[] = getFutureMonths();

  const handleOptionChange = (option: { name: string }) => {
    setSupplierOption(option);
  };

  const getForecastValue = (segment: string, ndc: string, date: string) => {
    let sourceData = fssforecastData;
    if (segment === 'NMC') sourceData = nmcforecastData;
    else if (segment === 'COVERED') sourceData = coveredDrugForecastData;

    const supplierndc = sourceData.filter(item => item.BulkNDC11 === ndc);
    if (supplierndc.length === 0) return '-';
    const forecast = supplierndc[0].forecast.filter(item => item.ForecastPeriod === date);
    if (forecast.length === 0) return '-';
    return Math.ceil(forecast[0].SupplierForecast).toLocaleString('en-US');
  };

  useEffect(() => {
    const currDt = new Date();
    const forecast_period = currDt
      .toISOString()
      .split('T')[0]
      .replace(/-\d{2}$/, '-01');
    getSupplierForecastData(forecast_period);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run on mount
  }, []);

  return {
    userModulesRoles,
    isSupplierForecastDownloading,
    forecastDates,
    isSupplierForecastLoading,
    supplierNames,
    supplierForecastData,
    supplierOption,
    fssforecastData,
    nmcforecastData,
    coveredDrugForecastData,
    issupplierForecastGenerating,
    isUnconstrainedForecastProgressLoading,
    percentProgress,
    searchInput,
    getSupplierForecastData,
    getForecastValue,
    handleOptionChange,
    generateSupplierForecast,
    isAllSupplierForecastDownloading,
    handleExport,
    handleExportAllSuppliers,
  };
};
